import 'whatwg-fetch';
import config from '../../config/config';

const {
    API_REVIEWS_URL
} = config;

export const reviewsApi = {
    fetchList: async (params = {}, id) => {
        const queryParams = new URLSearchParams({
            page: 1,
            per_page: 20,
            ...params,
        }).toString();

        const fetchOptions = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        }

        const response = await fetch(
            `${API_REVIEWS_URL}${id}?${queryParams}`,
            fetchOptions
        );

        if (!response.ok) {
            throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }

        const data = await response.json();

        return {
            data: Array.isArray(data) ? data : [],
        }
    }
}